import React, { useEffect, useState } from "react";
import useListOptions from "../../CustomHooks/useListOptions";
import FormikSelect from "../Formik/FormikSelect";
import SVGButton from "../Buttons/SVGButton";
import deleteIcon from "../../Images/Delete.svg";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../utilities/constants";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import { nameCreateGeneral } from "../../DataApi/generalApis/nameCreateGeneral";
import { useSession } from "../../authentications/SessionContext";
import { primaryColor } from "../../utilities/colors";

function ProductVariantRow({
  index,
  setFieldValue,
  item,
  name,
  disableInputs,
}) {
  const {
    options: attributesList,
    setOptions: setAttributesList,
    handleCustomSearch,
  } = useListOptions();

  const [attributesValueList, setAttributesValueList] = useState([]);
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;

  useEffect(() => {
    handleCustomSearch({
      model: "product.attribute",
      setState: setAttributesList,
      pagination: { limit: 300 },
    });
  }, []);

  useEffect(() => {
    if (item.attribute_id) {
      handleCustomSearch({
        model: "product.attribute.value",
        args: [["attribute_id", "=", item.attribute_id]],
        setState: setAttributesValueList,
        pagination: { limit: 300 },
      });
    }
  }, [item.attribute_id]);

  const handleCreateAttribute = async (name) => {
    try {
      const response = await nameCreateGeneral({
        company_id,
        context,
        args: [name],
        model: "product.attribute",
      });

      // console.log("API Response:", response); // Log response to check for errors

      if (response.result) {
        const [value, label] = response.result;
        findAndAddOption({
          incomingOption: response.result,
          setAvailableOptions: setAttributesList,
        });
        return { value, label };
      } else {
        console.error("Failed to create attribute:", response.error);
        return false;
      }
    } catch (error) {
      console.error("An error occurred while creating attribute:", error);
      return false;
    }
  };

  return (
    <tr key={index}>
      <td style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
        <FormikSelect
          name={`${name}.${index}.attribute_id`}
          options={attributesList}
          handleSearch={({ ...args }) => {
            handleCustomSearch({
              ...args,
              model: "product.attribute",
            });
          }}
          handleCreate={handleCreateAttribute}
          disabled={disableInputs}
          onChange={(op) => {
            // console.log(op, "VtexBrand");
            findAndAddOption({
              incomingOption: [op.value, op.label],
              setAvailableOptions: setAttributesList,
            });
          }}
        />
      </td>

      <td style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
        <FormikSelect
          name={`${name}.${index}.value_ids`}
          options={attributesValueList}
          disabled={disableInputs}
          isMulti
          handleSearch={({ ...args }) => {
            handleCustomSearch({
              ...args,
              model: "product.attribute.value",
              args: [["attribute_id", "=", item.attribute_id]],
            });
          }}
          //   disabled={checkDisableInputs({ ...item })}
          onChange={(op) => {
            // console.log(op, "VtexBrand");
            findAndAddOption({
              incomingOption: [op.value, op.label],
              setAvailableOptions: setAttributesValueList,
            });
          }}
        />
      </td>
      {!disableInputs && (
        <td className="d-flex  justify-content-center align-items-center mt-auto">
          <SVGButton
            icon={"deleteIcon"}
            hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
            onClick={() => {
              setFieldValue(`${name}.${index}`, { ...item, isDeleted: true });
            }}
          />
        </td>
      )}
    </tr>
  );
}

export default ProductVariantRow;
